$('.js-back-to-homepage').click(function (e) {
  window.location.href = $(this).data('url');
});
